<template>
    <b-popover :shown="onShow" :target="target" triggers="click blur" :show.sync="popoverShow" placement="bottom">
        <div class="row">
            <div class="col">{{ $t('Duplicate to tooth')}}:</div>
            <div class="col-auto">
                <custom-switch v-model="kid" :title="$t('Baby map') " id="kidOrNot1" class="m-0 p-0" />
            </div>
        </div>

        <image-map class="mb-4" :kid="kid" :selectable="true" v-model="selected" :width="20" :tooths="{}"></image-map>

        <div class="row">
            <div class="col-auto">
                <button class="btn btn-outline-secondary btn-sm mr-2" @click="all">{{$t('All')}}</button>
                <button class="btn btn-outline-secondary btn-sm mr-2" @click="allTop">{{$t('All top')}}</button>
                <button class="btn btn-outline-secondary btn-sm mr-2" @click="allBottom">{{$t('All bottom')}}</button>
                <button class="btn btn-outline-secondary btn-sm" v-if="selected.length>0" @click="clear">{{$t('Clear')}}</button>
            </div>
            <div class="col"></div>
            <div class="col-auto">
                <b-button variant="primary" :disabled="selected.length<=0" @click="duplicate">{{$t('Apply')}}</b-button>
            </div>
        </div>
    </b-popover>
</template>

<script>
import ImageMap from '@/components/Teeth/Map';
import CustomSwitch from '@/components/CustomSwitch';
export default {
    props: ['target', 'exam', 'action'],
    components: {
        ImageMap,
        CustomSwitch

    },
    data() {
        return {
            markAsDone: true,
            kid: false,
            data: [],
            selected: [],
            popoverShow: false,
        }
    },


    methods: {
        clear() {
            this.selected = [];
        },
        all() {
            this.allTop();
            this.allBottom();
        },
        allTop() {
            this.selected.push(...[18, 17, 16, 15, 14, 13, 12, 11, 28, 27, 26, 25, 24, 23, 22, 21])
        },
        allBottom() {
            this.selected.push(...[48, 47, 46, 45, 44, 43, 42, 41, 38, 37, 36, 35, 34, 33, 32, 31]);
        },
        duplicate() {
            let items = this.$unique(this.selected);
            this.action(items);
            this.$root.$emit('bv::hide::popover');
            this.$toasted.global.success({
                message: this.$t('Item has been saved')
            });

        },
        onShow() {
            this.$root.$emit('bv::hide::popover');
        },
        onShown() {
            this.data = this.value;

        },
    }
}
</script>
<style scoped>
 .popover{
        min-width:650px;
    }
</style>